import Banner from '../components/Banner';
import IntroSection from '../components/Intro'; 
import AuctionCarousel from '../components/AuctionCarousel';

const HomePage = () => {
    return (
        <>
            <Banner />
            <AuctionCarousel />
            <IntroSection />
        </>
    );
}

export default HomePage;

